// extracted by mini-css-extract-plugin
module.exports = {"container":"article-navigation_container__iZHPH","item":"article-navigation_item__L0pV7","active":"article-navigation_active__hLNOS"};